export default {
  0: { imageWidthDesktop: 230, imageWidthMobile: 180 },
  1: { imageWidthDesktop: 0, imageWidthMobile: 0 },
  2: { showBorder: true },
  3: { imageWidthDesktop: 230, imageWidthMobile: 'auto', negativeImageMobileIndent: true },
  4: { imageWidthDesktop: 180, imageWidthMobile: 180, thinText: true, showTimeBefore: true },
};
